import * as openLayer from 'openlayers';

export const MIN_VALID_COORDINATE_VALUE = -1e-300;

export function isValidCoordinate(coordinates: openLayer.Coordinate) {
  return coordinates && coordinates.length === 2 &&
    coordinates[0] > MIN_VALID_COORDINATE_VALUE && coordinates[1] > MIN_VALID_COORDINATE_VALUE;
}
